var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentumSpikesDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.66 36.78a1.286 1.286 0 001.786-.345l6.483-9.585a1.286 1.286 0 10-2.13-1.44l-4.744 7.013-4.65-24.095a1.286 1.286 0 00-.855-.976L7.693 3.066a1.286 1.286 0 00-.814 2.44l12.144 4.048 4.508 23.356-7.014-4.744a1.286 1.286 0 10-1.44 2.13l9.584 6.483z"
  })));
}
export default SvgMomentumSpikesDrop;